import { css as e, keyframes as t, styled as n } from "styled-components";
import * as r from "@radix-ui/react-dialog";
//#region src/components/FullscreenGallery/styles.ts
var i = ({ theme: e }) => e.mode === "dark" ? e.colors.background : "#ffffff", a = t`
    from { opacity: 0; }
    to   { opacity: 1; }
`, o = t`
    from { opacity: 0; }
    to   { opacity: 1; }
`, s = t`
    from { opacity: 0; transform: scale(0.98); }
    to   { opacity: 1; transform: scale(1); }
`, c = n(r.Overlay)`
    position: fixed;
    inset: 0;
    z-index: 1001;
    background: ${i};
    animation: ${a} ${({ theme: e }) => e.transitions.fast};
`, l = n(r.Content)`
    position: fixed;
    inset: 0;
    z-index: 1002;
    display: flex;
    flex-direction: column;
    outline: none;
    animation: ${s} ${({ theme: e }) => e.transitions.normal};
`, u = n(r.Title)`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    border: 0;
`, d = n.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(2, 3)};
    flex-shrink: 0;
    z-index: 10;
`, f = n.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(2)};
    padding: ${({ theme: e }) => e.spacing(2, 3)};
    flex-shrink: 0;
    z-index: 10;
`, p = n.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${({ theme: e }) => e.spacing(1)};
`, m = n.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(.25)};
    min-width: 0;
`, h = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.foreground};
    max-width: 60vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: none;
`, g = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    user-select: none;
`, _ = n.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid ${({ theme: e }) => e.glass.pillBorder};
    border-radius: ${({ theme: e }) => e.radii.full};
    background: ${({ theme: e }) => e.glass.pillBackground};
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    color: ${({ theme: e }) => e.colors.foreground};
    cursor: pointer;
    transition: all ${({ theme: e }) => e.transitions.fast};

    &:hover {
        background: ${({ theme: e }) => e.colors.accent};
    }
`, v = n.div`
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 0;
    padding: 0 64px;
    touch-action: none; /* We handle all touch gestures ourselves */
    user-select: none;

    @media (max-width: 640px) {
        padding: 0 8px;
    }
`, y = n.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(${({ $scale: e }) => e})
        translate(${({ $tx: e }) => e}%, ${({ $ty: e }) => e}%);
    transform-origin: center center;
    transition: ${({ $isZoomed: e, $scale: t }) => t === 1 || t === 2 ? "transform 250ms ease" : "none"};
    cursor: ${({ $isZoomed: e }) => e ? "grab" : "zoom-in"};

    &:active {
        cursor: ${({ $isZoomed: e }) => e ? "grabbing" : "zoom-in"};
    }
`, b = n.div`
    position: relative;
    width: 100%;
    height: 100%;
`, x = n.img`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    user-select: none;
    -webkit-user-drag: none;
    pointer-events: none; /* Let ZoomContainer handle all interactions */

    ${({ $entering: t, theme: n }) => t && e`
            animation: ${o} ${n.transitions.normal};
        `}
`, S = n.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ $side: e }) => e === "left" ? "left: 16px;" : "right: 16px;"}
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border: 1px solid ${({ theme: e }) => e.glass.pillBorder};
    border-radius: ${({ theme: e }) => e.radii.full};
    background: ${({ theme: e }) => e.glass.pillBackgroundStrong};
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    color: ${({ theme: e }) => e.colors.foreground};
    cursor: pointer;
    box-shadow: ${({ theme: e }) => e.glass.shadow};
    transition: all ${({ theme: e }) => e.transitions.fast};

    &:hover {
        background: ${({ theme: e }) => e.colors.accent};
        transform: translateY(-50%) scale(1.05);
    }

    &:active {
        transform: translateY(-50%) scale(0.95);
    }

    /* Hide on mobile — swipe handles it */
    @media (max-width: 640px) {
        display: none;
    }
`, C = n.div`
    flex-shrink: 0;
    padding: ${({ theme: e }) => e.spacing(1.5, 3)};
    z-index: 10;
`, w = n.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }
`, T = n.button`
    flex-shrink: 0;
    width: 64px;
    height: 48px;
    padding: 0;
    border: none;
    border-radius: ${({ theme: e }) => e.radii.md};
    overflow: hidden;
    cursor: pointer;
    outline: 2px solid
        ${({ $active: e, theme: t }) => e ? t.colors.foreground : "transparent"};
    outline-offset: 2px;
    opacity: ${({ $active: e }) => e ? 1 : .5};
    transition: all ${({ theme: e }) => e.transitions.fast};

    &:hover {
        opacity: ${({ $active: e }) => e ? 1 : .8};
        transform: scale(1.05);
    }

    @media (max-width: 640px) {
        width: 52px;
        height: 40px;
    }
`, E = n.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
    -webkit-user-drag: none;
`;
//#endregion
export { _ as CloseBtn, l as Container, g as Counter, u as HiddenTitle, b as ImageFrame, v as MainArea, x as MainImg, S as NavBtn, c as Overlay, h as SectionLabel, T as ThumbnailBtn, E as ThumbnailImg, w as ThumbnailScroller, C as ThumbnailStripWrapper, m as TopBarCenter, p as TopBarEnd, f as TopBarGrid, d as TopBarWrapper, y as ZoomContainer };
